import loadable from '@loadable/component';

export const SearchVolopsRefinementsLoadable = loadable(
  () => import('./SearchVolopsRefinements'),
  { resolveComponent: (module) => module.SearchVolopsRefinements },
);
